import { render, staticRenderFns } from "./Doglist.vue?vue&type=template&id=3a15fe28&scoped=true"
import script from "./Doglist.vue?vue&type=script&lang=js"
export * from "./Doglist.vue?vue&type=script&lang=js"
import style0 from "./Doglist.vue?vue&type=style&index=0&id=3a15fe28&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a15fe28",
  null
  
)

export default component.exports